module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ctit"
  }, [_c('b', [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "introtxt"
  }, [_c('b', [_c('i', [_c('span', {
    staticClass: "lcol"
  }, [_vm._v("Welcome to my book!")])])]), _vm._v(" "), _c('i', [_vm._v("We’re going to cover how to make seven enchanting softies, each using only three pattern pieces. The book is split into three main sections. The first is simple: basic techniques for reading and preparing the templates. The second section is where things get exciting: you get to choose and create your animal character! And finally, in the third section, you decide how to accessorize your softie (if you want to!). Each animal is simple, customizable, and as sweet as can be.")])]), _vm._v(" "), _c('p', {
    staticClass: "introtxt"
  }, [_c('i', [_vm._v("I wrote this book because I have a love for crafting, and I want to share it with others. This book is suitable for those who have never crafted before, as each step is explained clearly and in great detail. I know that by the end of the book, you will feel confident about stitches, pattern marks, and all the relevant techniques necessary to make every project an outstanding success.")])]), _vm._v(" "), _c('p', {
    staticClass: "introtxt"
  }, [_c('i', [_vm._v("Many people think you need to be able to paint the Sistine Chapel to be an artist, but that couldn’t be further from the truth. Just like learning to drive or swimming in the deep end, you start by learning a simple skill and build on it. This book is one building block for constructing a creative future.")])]), _vm._v(" "), _c('p', {
    staticClass: "introtxt"
  }, [_c('i', [_vm._v("Advanced crafters will also love how quick these little characters are to make. So, surprise yourself and others by making these animals. The best part is that they are "), _c('b', [_vm._v("fun, fun, fun")]), _vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "introtxt"
  }, [_c('i', [_vm._v("So, let’s get going.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10aa397c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_introduction.vue
// module id = 72
// module chunks = 0